import type React from "react";

import { Legend, Pie, PieChart as RechartsPieChart, ResponsiveContainer, Tooltip } from "recharts";
import styled from "styled-components";

import { DARK_BLUE } from "theme/colors";

import type { TooltipContentProps } from "../TooltipContent";
import { TooltipContent } from "../TooltipContent";
import { DEFAULT_HEIGHT } from "../utils";

interface PieChartProps {
  data: unknown[];
  height?: number;
  label?: React.ReactNode;
  tooltipProps?: TooltipContentProps;
}

export const PieChart: React.FC<PieChartProps> = ({ data, height, label, tooltipProps }) => {
  return (
    <Container style={{ height: height || DEFAULT_HEIGHT }}>
      <ResponsiveContainer width="100%" height="100%">
        <RechartsPieChart>
          <Pie
            data={data}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius="60%"
            outerRadius="88%"
            startAngle={90}
            endAngle={-270}
            strokeWidth={0}
          />
          <Tooltip content={<TooltipContent {...tooltipProps} />} wrapperStyle={{ zIndex: 1000 }} />
          <Legend
            verticalAlign="bottom"
            wrapperStyle={{ paddingTop: 18, display: "flex", gap: "16px", justifyContent: "center" }}
            iconType="circle"
            formatter={(value: string) => (
              <span style={{ color: DARK_BLUE[100], fontSize: 11, fontWeight: 500 }}>{value}</span>
            )}
          />
        </RechartsPieChart>
      </ResponsiveContainer>
      {label && <LabelContainer>{label}</LabelContainer>}
    </Container>
  );
};

const Container = styled.div`
  flex: 1 1 auto;
  position: relative;
`;

const LabelContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 18px));
`;
